/* Fælles for grading-siderne: de danske stadie-etiketter OG pegepinden til en
   påbegyndt betaling. Indlæses af /pages/min-grading, /pages/konto og
   /pages/grading-indlevering (se de tre sektioner).

   Hvorfor en fil for sig:
   1) Etiketterne stod før to steder — i mtw-grading.js og i mtw-konto.js — og
      drev fra hinanden præcis som man kunne frygte: da 'awaiting_cards' kom
      til i mgrading, fik statussiden en dansk tekst, mens kontosiden blev ved
      med at skrive den rå nøgle "awaiting_cards" ud til kunden. To tabeller
      over de samme nøgler ER fejlen; her er der kun én.
   2) Betalingspegepinden skrives af wizarden og læses/ryddes af statussiden.
      Den skal derfor kunne læses fra begge sider, med ét format og ét sted at
      validere det.

   Alle opslag sker med nøgler fra et eksternt payload, så hver tabel er
   prototypeløs (Object.create(null)) og læses som TABEL[nøgle] || fallback.
   Et almindeligt objekt-literal ville finde arvede navne — HOVED['constructor']
   ville give en funktion, ikke undefined, og "|| fallback" ville aldrig fyre. */
(function () {
  'use strict';

  // Samme form som mgradings generator (lib/store/ref.ts: 5 tegn fra Crockford
  // base32 — ingen I, L, O eller U) og samme mønster som ?ny=-porten i
  // mtw-grading.js. Alt andet er ikke en reference, uanset hvor det kom fra.
  var REF_MOENSTER = /^ORD-[0-9A-HJKMNP-TV-Z]{5}$/;

  var BETALING_NOEGLE = 'mtwg-betaling-v1';
  // Et betalingslink, der er en uge gammelt, er ikke længere en hjælp — og
  // pegepinden skal ikke ligge i en browser på ubestemt tid.
  var BETALING_MAKS_DAGE = 7;

  // Sidste udvej. Aldrig en rå nøgle ud til kunden: en ny stageKey fra
  // mgrading skal degradere til dansk, ikke til en identifikator.
  var UKENDT = 'Undervejs';

  var HOVED = Object.create(null);
  HOVED.at_matraws = 'Modtaget hos Matraws';
  HOVED.at_psa = 'Hos PSA';
  HOVED.grading = 'Grading hos PSA';
  HOVED.back = 'Tilbage hos Matraws';
  // 'awaiting_cards' står bevidst IKKE her: det er aldrig en nøgle i main[],
  // og pille() svarer på det, før HOVED slås op.

  var FULFIL = Object.create(null);
  FULFIL.pickup = 'Klar til afhentning';
  FULFIL.ship = 'Sendt til dig';

  var AFSLUTTET = Object.create(null);
  AFSLUTTET.pickup = 'Afhentet';
  AFSLUTTET.ship = 'Leveret';

  var PSA = Object.create(null);
  PSA.OrderPrep = 'Klargøring';
  PSA.ResearchAndID = 'Identifikation';
  PSA.Grading = 'Grading';
  PSA.Assembly = 'Indkapsling';
  PSA.QACheck = 'Kvalitetstjek';
  PSA.GradesReady = 'Karakterer klar';
  PSA.Completed = 'Sendt retur til Matraws';

  // Betalingstilstanden fra payloadet (mgrading: not_required | awaiting |
  // paid | cancelled | refunded). Tabellen svarer på ét spørgsmål: er der
  // betalt? 'not_required' er den operatør-tastede ordre, der blev betalt uden
  // for systemet. Alt andet — awaiting, cancelled, refunded og enhver værdi,
  // vi ikke kender — regnes som IKKE betalt.
  var BETALT = Object.create(null);
  BETALT.paid = true;
  BETALT.not_required = true;

  // Hvad pillen siger, når kortene endnu ikke er sendt af sted OG der ikke er
  // betalt. "Afventer dine kort" ville her udpege den forkerte part som den,
  // der holder tingene tilbage — vi venter på pengene, ikke på kortene.
  var UBETALT = Object.create(null);
  UBETALT.awaiting = 'Afventer betaling';
  UBETALT.cancelled = 'Betaling annulleret';
  UBETALT.refunded = 'Beløbet er refunderet';

  function betalt(o) {
    return BETALT[o && o.paymentState] === true;
  }

  /** Teksten i pillen på ordrekortet — statussiden og kontosiden bruger
   *  præcis den samme, så de to sider ikke kan sige hver sit om samme ordre. */
  function pille(o) {
    if (!o) return UKENDT;
    if (o.stageKey === 'awaiting_cards') {
      return betalt(o) ? 'Afventer dine kort' : (UBETALT[o.paymentState] || UKENDT);
    }
    if (o.stageKey === 'complete') return AFSLUTTET[o.fulfillmentMethod] || 'Afsluttet';
    if (o.stageKey === 'fulfil') return FULFIL[o.fulfillmentMethod] || FULFIL.ship;
    return HOVED[o.stageKey] || UKENDT;
  }

  /** Label på et trin i main[]. */
  function hoved(o, t) {
    if (t && t.key === 'fulfil') return FULFIL[o && o.fulfillmentMethod] || FULFIL.ship;
    return HOVED[t && t.key] || UKENDT;
  }

  /** Label på et trin i psa[]. */
  function psa(key) {
    return PSA[key] || UKENDT;
  }

  // Kun http(s). Pegepinden ligger i kundens eget lager, men en værdi derfra
  // er stadig en værdi udefra: uden denne port kunne en javascript:-URL ende
  // i et href på siden.
  function sikkerUrl(u) {
    return /^https?:\/\//i.test(String(u || '')) ? String(u) : null;
  }

  /* ---------- Påbegyndt betaling ----------
     Wizarden rydder kladden, når kunden sendes til checkout — ellers ville en
     genindlæsning kunne sende den samme indlevering af sted igen. Men uden et
     spor tilbage kan en kunde, der lukker checkout-fanen, kun komme videre ved
     at udfylde wizarden FORFRA, og det opretter en ANDEN ordre med sit eget
     betalingslink for de samme fysiske kort. To fakturaer, ét parti kort.
     Derfor gemmes referencen + betalingslinket her, indtil ordren ikke længere
     venter på penge (statussiden rydder). localStorage frem for
     sessionStorage: en lukket checkout-fane tager sessionen med sig, og det er
     netop den situation, pegepinden findes for. */
  function gemBetaling(ref, url) {
    var r = String(ref || '');
    var u = sikkerUrl(url);
    if (!REF_MOENSTER.test(r) || !u) return;
    try {
      window.localStorage.setItem(BETALING_NOEGLE, JSON.stringify({ ref: r, url: u, ts: Date.now() }));
    } catch (e) {
      /* privat vindue eller fuldt lager — pegepinden er en hjælp, ikke et krav */
    }
  }

  function rydBetaling() {
    try { window.localStorage.removeItem(BETALING_NOEGLE); } catch (e) {}
  }

  /** {ref, url} eller null. Alt valideres på vej ud — en post, der ikke holder,
   *  ryddes med det samme i stedet for at blive liggende og blive prøvet igen. */
  function hentBetaling() {
    var raa;
    try {
      raa = window.localStorage.getItem(BETALING_NOEGLE);
    } catch (e) {
      return null;
    }
    if (!raa) return null;
    var g;
    try { g = JSON.parse(raa); } catch (e) { rydBetaling(); return null; }
    var url = g && sikkerUrl(g.url);
    var ts = g && Number(g.ts);
    if (!g || typeof g !== 'object' || !url || !REF_MOENSTER.test(String(g.ref)) || !isFinite(ts)) {
      rydBetaling();
      return null;
    }
    if (Date.now() - ts > BETALING_MAKS_DAGE * 24 * 60 * 60 * 1000) {
      rydBetaling();
      return null;
    }
    return { ref: String(g.ref), url: url };
  }

  /* ---------- App Proxy-stien ----------
     Sektionernes indstilling grading_proxy_base (sendt som data-proxy-base)
     er det ene sted, stien skiftes ved flytningen fra /apps/portal/grading til
     /apps/grading. Værdien kommer fra en tekstindstilling, så den valideres:
     kun en relativ sti under /apps/ — aldrig en absolut URL, //host,
     javascript: eller en sti med ../ — ellers bruges standarden. Slutter den
     med / fjernes det, så base + '/katalog' ikke bliver til '//katalog'. */
  var PROXY_STANDARD = '/apps/portal/grading';

  function proxyBase(raa) {
    var s = String(raa == null ? '' : raa).replace(/^\s+|\s+$/g, '').replace(/\/+$/, '');
    if (!/^\/apps\/[A-Za-z0-9_\-]+(\/[A-Za-z0-9_\-]+)*$/.test(s)) return PROXY_STANDARD;
    return s;
  }

  /* ---------- Forsikringslinjen (D-A / D-G1) ----------
     Wizarden beregner selv "I alt" og skal ramme Shopify-fakturaen på øren.
     mgrading regner: skøn = Σ (hvert kort afrundet til øre), præmie =
     Math.round(skøn i øre × sats / 100). Præmien er momsfri; resten er inkl.
     moms. Værdier parses som i indsendelsen (komma → punktum); en værdi, der
     ikke er et tal over 0, tæller ikke med. */
  function vaerdiTal(v) {
    var n = Number(String(v == null ? '' : v).replace(',', '.'));
    return isFinite(n) && n > 0 ? n : 0;
  }

  function insurancePremiumOre(values, ratePct) {
    var rate = Number(ratePct);
    if (!(rate > 0) || !isFinite(rate) || !values || !values.length) return 0;
    // Hvert kort afrundes til øre FØR summen, præcis som mgradings money() pr. kort
    // (quote.ts). Ellers kan værdier med 3+ decimaler give 1 øres forskel til fakturaen.
    var basisOre = 0;
    for (var i = 0; i < values.length; i++) basisOre += Math.round(vaerdiTal(values[i]) * 100);
    return Math.round(basisOre * Math.round(rate * 100) / 10000);
  }

  /** Kun når kataloget udtrykkeligt siger insurance.enabled === true. Mangler
   *  feltet (gammel backend) eller er det false, er svaret 0 — siden er
   *  uændret. */
  function insuranceRate(insurance) {
    if (!insurance || insurance.enabled !== true) return 0;
    var r = Number(insurance.ratePct);
    return isFinite(r) && r > 0 ? r : 0;
  }

  /** {gradingOre, premiumOre, totalOre}. unitOre = pris pr. kort i øre. */
  function quoteOre(unitOre, antal, values, insurance) {
    var gradingOre = unitOre * antal;
    var premiumOre = antal > 0 ? insurancePremiumOre(values, insuranceRate(insurance)) : 0;
    return { gradingOre: gradingOre, premiumOre: premiumOre, totalOre: gradingOre + premiumOre };
  }

  var api = {
    PROXY_STANDARD: PROXY_STANDARD,
    proxyBase: proxyBase,
    insurancePremiumOre: insurancePremiumOre,
    insuranceRate: insuranceRate,
    quoteOre: quoteOre,
    UKENDT: UKENDT,
    REF_MOENSTER: REF_MOENSTER,
    betalt: betalt,
    pille: pille,
    hoved: hoved,
    psa: psa,
    sikkerUrl: sikkerUrl,
    gemBetaling: gemBetaling,
    hentBetaling: hentBetaling,
    rydBetaling: rydBetaling
  };

  if (typeof window !== 'undefined') window.MTWG_FAELLES = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})();
